/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

class BaseStep {
	constructor(options, moduleOptions) {
		this.badgesFeature = moduleOptions.badgesFeature;
		this.id = options.id;
		this.owner = options.owner;
		this.ownerWidget = options.ownerWidget;
		this.logger = options.logger;
		this.visAPI = options.visAPI;
		this.dashboardApi = options.dashboardApi;

		this._initializeStep = this.owner._initializeStep.bind(this.owner);
		this._isStepComplete = this.owner._isStepComplete.bind(this.owner);
		this._completeStep = this.owner._completeStep.bind(this.owner);
		this._logRenderContext = this.owner._logRenderContext.bind(this.owner);


		if (this.id) {
			this._initializeStep(this.id);
		}


	}

	getRenderState() {
		return this.owner._renderState;
	}

	clearError() {
		// todo: no equivalent new api for visHelper;
		this.visAPI.visHelper.clearError();
	}

	showError(msg, params) {
		// todo: no equivalent new api for visHelper;
		this.visAPI.visHelper.showError(msg, params);
	}

}

export default BaseStep;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-badges/src/js/rendersequence/BaseStep.js